import { activatePipeline, pausePipeline } from 'js/actions/pipelines';
import { restorePipeline } from 'new/actions/pipelines/archivalActions';
import { BulkAction, BulkActionApplicability, BulkActionItem, BulkActionProgress } from './types';

export const INITIAL_PROGRESS: BulkActionProgress = {
  open: false,
  action: null,
  total: 0,
  applicable: 0,
  completed: 0,
  succeeded: 0,
  failed: 0,
  skipped: 0,
  status: 'idle',
  log: [],
  currentName: undefined,
};

export const appliesTo = (action: BulkAction, item: BulkActionItem): BulkActionApplicability => {
  switch (action) {
    case 'activate':
      if (item.archived) return { apply: false, reason: 'Archived — unarchive first' };
      if (item.active) return { apply: false, reason: 'Already active' };
      return { apply: true };
    case 'pause':
      if (item.archived) return { apply: false, reason: "Archived flows can't be paused" };
      if (!item.active) return { apply: false, reason: 'Already paused' };
      return { apply: true };
    case 'unarchive':
      if (!item.archived) return { apply: false, reason: 'Not archived' };
      return { apply: true };
  }
};

export const getItemsWithApplicability = (
  action: BulkAction,
  items: BulkActionItem[],
): Array<{ item: BulkActionItem; applicability: BulkActionApplicability }> =>
  items.map((item) => ({ item, applicability: appliesTo(action, item) }));

export const getApplicableCount = (action: BulkAction, items: BulkActionItem[]): number =>
  getItemsWithApplicability(action, items).filter(({ applicability }) => applicability.apply)
    .length;

export const getBulkActionCounts = (items: BulkActionItem[]): Record<BulkAction, number> => ({
  activate: getApplicableCount('activate', items),
  pause: getApplicableCount('pause', items),
  unarchive: getApplicableCount('unarchive', items),
});

export const actionThunkByAction: Record<BulkAction, (flowNodeId: number) => any> = {
  // A bulk bar can't ask per flow, and run_now=true is the only value correct for every connector
  // class: sources with no recurring schedule are never picked up by control on their own, so
  // run_now=false would silently leave them activated but never started.
  activate: (flowNodeId) => activatePipeline(flowNodeId, true, { ignoreErrors: true }),
  pause: (flowNodeId) => pausePipeline(flowNodeId, { ignoreErrors: true }),
  unarchive: (flowNodeId) => restorePipeline(flowNodeId, { ignoreErrors: true }),
};
